export default __webpack_public_path__ + "static/media/game_logo.min.01cfe23a.png";